
export class UserSubmittableDataRecord {
    Id: number;
    WellId: number;
}
